module.exports = __webpack_public_path__ + "img/9.4a13b8e4.jpg";